import type { NotificationsViewsInvalidateSuffixes } from "./notifications-view.type";

export const NOTIFICATIONS_VIEWS_INVALIDATE_SUFFIXES: NotificationsViewsInvalidateSuffixes =
  {
    // Invalidate all notifications queries in "All" tab
    all_tab: "*",
    // Invalidate all notifications queries in "Unread" tab
    // except the current view (aka `unread` query)
    unread_tab: ["unread_count", "all"],
  };
